import {ContactClient} from "./contact"
import axios from "axios";

const contactClient = new ContactClient(axios); 

export {contactClient};